module.exports = __webpack_public_path__ + "h5/img/noCart.6f2abfef.png";